import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Download, Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SubBrokerUploadHistory() {
  const { api } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/subbroker/upload-history");
        setRows(data.batches || []);
      } finally { setLoading(false); }
    })();
  }, [api]);

  const downloadErrors = async (batchId) => {
    const token = localStorage.getItem("token");
    const resp = await fetch(`${API_URL}/api/subbroker/upload-history/${batchId}/errors`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await resp.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `errors_${batchId.slice(0, 8)}.csv`; a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6" data-testid="subbroker-upload-history-page">
      <div>
        <h1 className="text-3xl font-bold text-gray-800">Upload History</h1>
        <p className="text-sm text-gray-500">Audit trail of all sub-broker bulk uploads</p>
      </div>
      <Card className="p-4">
        {loading ? <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-gray-500" /></div> : (
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-gray-500 border-b">
              <tr>
                <th className="text-left py-2 px-2">Batch ID</th>
                <th className="text-left py-2 px-2">File</th>
                <th className="text-left py-2 px-2">Uploaded By</th>
                <th className="text-left py-2 px-2">Date</th>
                <th className="text-right py-2 px-2">Total</th>
                <th className="text-right py-2 px-2">Success</th>
                <th className="text-right py-2 px-2">Failures</th>
                <th className="py-2 px-2"></th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr><td colSpan={8} className="text-center text-gray-400 py-12">No uploads yet</td></tr>
              ) : rows.map((b) => (
                <tr key={b.id} className="border-b border-gray-100 hover:bg-gray-50" data-testid={`history-row-${b.id.slice(0,8)}`}>
                  <td className="py-2 px-2 font-mono text-xs">{b.id.slice(0, 8)}</td>
                  <td className="py-2 px-2">{b.file_name}</td>
                  <td className="py-2 px-2 text-gray-600">{b.uploaded_by_name}</td>
                  <td className="py-2 px-2 text-xs">{new Date(b.upload_date).toLocaleString()}</td>
                  <td className="py-2 px-2 text-right">{b.total_records}</td>
                  <td className="py-2 px-2 text-right text-emerald-700 font-medium">{b.success_count}</td>
                  <td className="py-2 px-2 text-right text-rose-700 font-medium">{b.failure_count}</td>
                  <td className="py-2 px-2">
                    {b.failure_count > 0 && (
                      <Button size="sm" variant="ghost" onClick={() => downloadErrors(b.id)} data-testid={`history-err-${b.id.slice(0,8)}`}>
                        <Download className="w-3.5 h-3.5" />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
